import React from 'react';

const Shorts = () => {
  return <div className='center'>This channel doesn't have any shorts</div>;
};

export default Shorts;
